// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"7065e027","133":"51fb842c","295":"864f3bb6","315":"c6138624","474":"c6138624","487":"21c3ef7c","617":"dbdaa83e","641":"23052763","698":"606f7346","891":"2f842947","919":"3560ba41"}[chunkId] + ".chunk.css";
};